'use strict';

var AdvancedHepGridDeleteRowButtonDirective = function AdvancedHepGridDeleteRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/advanced-hep-grid-delete-row-button.html'),
    controller: 'AdvancedHepGridDeleteRowButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
AdvancedHepGridDeleteRowButtonDirective.$inject = [];
module.exports = AdvancedHepGridDeleteRowButtonDirective;